// extracted by mini-css-extract-plugin
module.exports = {"cat_image":"cat_image___1rU6Z"};